import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Code2, TerminalSquare } from "lucide-react";
import { FaJava,FaPython,FaJs   } from "react-icons/fa";
import { SiCplusplus } from "react-icons/si";
import "./css/Sidebar.css";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="logo">
        {/* <div className="circle">∞</div> */}
      </div>

      <div className="nav-icons">
        <NavLink
          to="/dashboard"
          className={({ isActive }) => (isActive ? "icon-box active" : "icon-box")}
        >
          <Home size={22} />
          <span className="label">Dashboard</span>
        </NavLink>

        <NavLink
          to="/compile/java"
          className={({ isActive }) => (isActive ? "icon-box active" : "icon-box")}
        >
          <FaJava size={22} />
          <span className="label">Java</span>
        </NavLink>

        <NavLink
          to="/compile/python"
          className={({ isActive }) => (isActive ? "icon-box active" : "icon-box")}
        >
          <FaPython  size={22} />
          <span className="label">Python</span>
        </NavLink>

        <NavLink
          to="/compile/js"
          className={({ isActive }) => (isActive ? "icon-box active" : "icon-box")}
        >
          <FaJs  size={22} />
          <span className="label">JS</span>
        </NavLink>

        <NavLink
          to="/compile/cpp"
          className={({ isActive }) => (isActive ? "icon-box active" : "icon-box")}
        >
          <SiCplusplus size={22} />
          <span className="label">CPP</span>
        </NavLink>

        <NavLink
          to="/compile/c"
          className={({ isActive }) => (isActive ? "icon-box active" : "icon-box")}
        >
          <p style={{fontSize:20,fontWeight:900}}>C</p>
          <span className="label">C</span>
        </NavLink>

        <NavLink
          to="/editor/text"
          className={({ isActive }) => (isActive ? "icon-box active" : "icon-box")}
        >
          <Code2 size={22} />
          <span className="label">Text</span>
        </NavLink>
      </div>

      <div className="footer-text">Brand<br />Appairt</div>
    </div>
  );
};

export default Sidebar;
